import { z } from 'zod';
import { USER_ROLES } from '../enums.js';
import { latitude, localeSchema, longitude } from './common.js';
/**
 * Управление пользователями в админке — ФТ-9.6, ФТ-9.9.
 *
 * Точка сборки курьера здесь присутствует **только на чтение**: задаёт её сам
 * исполнитель через `PATCH /api/profile`, администратор её видит, но не правит
 * (docs/04-api.md).
 */
export const adminUser = z.object({
    id: z.number().int().positive(),
    role: z.enum(USER_ROLES),
    telegram_id: z.number().int().nullable(),
    telegram_username: z.string().nullable(),
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    phone: z.string().nullable(),
    login: z.string().nullable(),
    locale: localeSchema,
    is_blocked: z.boolean(),
    created_at: z.string(),
    /** Точка сборки. Только чтение. */
    pickup_lat: latitude.nullable(),
    pickup_lon: longitude.nullable(),
    pickup_address_text: z.string().nullable(),
    /**
     * Незакрытые заказы, где пользователь — курьер. Нужен перед блокировкой:
     * заказы сами себя не переназначат, и администратор должен видеть, что
     * останется без исполнителя.
     */
    active_orders: z.number().int(),
});
export const adminUsersQuery = z.object({
    role: z.enum(USER_ROLES).optional(),
    /** Поиск по имени, телефону, username и telegram_id. */
    q: z.string().trim().max(100).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(100),
});
/**
 * Заведение курьера по `telegram_id` — ФТ-1.4.
 *
 * Если пользователь с таким id уже есть, ему меняется роль; если нет —
 * создаётся заготовка, которая свяжется с живым аккаунтом при первом `/start`.
 */
export const createCourierBody = z.object({
    telegram_id: z.number().int().positive(),
    first_name: z.string().trim().min(1).max(100).optional(),
    phone: z.string().trim().max(32).optional(),
});
export const updateUserBody = z
    .object({
    role: z.enum(USER_ROLES).optional(),
    is_blocked: z.boolean().optional(),
})
    .refine((v) => v.role !== undefined || v.is_blocked !== undefined, {
    message: 'Укажите роль или блокировку',
});
//# sourceMappingURL=adminUsers.js.map